<template>
  <div class="d-flex flex-column">
    <v-btn
      color="RMwhite"
      class="pa-0"
      style="border-radius: 4px 4px 0px 0px!important;"
      min-height="40"
      min-width="40"
      @click="zoomIn()"
    >
      <SvgIcon
        :title="'Zoom in'"
        :path="zoomInSvg"
      />
    </v-btn>
    <v-divider
      class="ma-0 pa-0"
      width="40"
    />
    <v-btn
      color="RMwhite"
      class="pa-0"
      style="border-radius: 0px 0px 4px 4px!important;"
      min-height="40"
      min-width="40"
      @click="zoomOut()"
    >
      <SvgIcon
        :rotate="'90'"
        :title="'Zoom out'"
        :path="zoomOutSvg"
      />
    </v-btn>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { svgZoomIn, svgZoomOut } from '@/svg.js';

export default {
  components: {
    SvgIcon: () => import('@/components/utils/SvgIcon')
  },
  data() {
    return {
      zoomInSvg: svgZoomIn,
      zoomOutSvg: svgZoomOut
    };
  },
  methods: {
    ...mapActions(['zoomIn', 'zoomOut'])
  }
};
</script>
